(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    if (window.IBPalsCartDrawerInitialized) return;
    window.IBPalsCartDrawerInitialized = true;

    var lastTrigger = null;
    var cartMutationQueue = Promise.resolve();
    var pendingLineMutations = new Map();
    var lockedPageScrollY = 0;

    function getDrawer() {
      return document.getElementById('CartDrawer');
    }

    function getRoot() {
      return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    }

    function getSectionsToRender() {
      var sections = ['cart-drawer'];
      var cartPage = document.querySelector('[data-cart-page-section-id]');
      if (cartPage && cartPage.dataset.cartPageSectionId) {
        sections.push(cartPage.dataset.cartPageSectionId);
      }
      return sections;
    }

    function dispatchCartSections(sections, source) {
      var drawer = getDrawer();
      document.dispatchEvent(new CustomEvent('ibpals:cart-sections', {
        detail: {
          sections: sections || {},
          itemCount: Number(drawer ? drawer.dataset.cartItemCount : 0),
          source: source
        }
      }));
    }

    function setTriggerState(isOpen) {
      document.querySelectorAll('[data-cart-drawer-trigger]').forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }

    function announce(message) {
      var region = document.querySelector('[data-cart-live-region]');
      if (!region) return;
      region.textContent = '';
      window.setTimeout(function () {
        region.textContent = message;
      }, 50);
    }

    function updateCartCount(count) {
      document.querySelectorAll('[data-cart-count-badge]').forEach(function (badge) {
        badge.textContent = String(count);
        badge.hidden = count === 0;
      });
    }

    function lockPageScroll() {
      var root = document.documentElement;
      if (root.classList.contains('cart-drawer-open')) return;
      lockedPageScrollY = window.scrollY;
      root.style.setProperty('--cart-drawer-page-offset', -lockedPageScrollY + 'px');
      root.classList.add('cart-drawer-open');
    }

    function unlockPageScroll() {
      var root = document.documentElement;
      if (!root.classList.contains('cart-drawer-open')) return;
      root.classList.remove('cart-drawer-open');
      root.style.removeProperty('--cart-drawer-page-offset');
      window.scrollTo(0, lockedPageScrollY);
    }

    function openDrawer(trigger) {
      var drawer = getDrawer();
      if (!drawer) return;
      lastTrigger = trigger || lastTrigger;
      if (!drawer.open) {
        drawer.showModal();
        lockPageScroll();
        drawer.addEventListener('close', function () {
          unlockPageScroll();
          setTriggerState(false);
          if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
        }, { once: true });
      }
      setTriggerState(true);
      var closeButton = drawer.querySelector('[data-cart-drawer-close]');
      if (closeButton) closeButton.focus();
    }

    function closeDrawer() {
      var drawer = getDrawer();
      if (drawer && drawer.open) drawer.close();
    }

    function showCartError(message) {
      var drawer = getDrawer();
      var errorElement = drawer ? drawer.querySelector('[data-cart-error]') : null;
      if (!errorElement) return;
      errorElement.textContent = message || drawer.dataset.errorText;
      errorElement.hidden = false;
    }

    function enqueueCartMutation(task) {
      var queued = cartMutationQueue.then(task, task);
      cartMutationQueue = queued.catch(function () {});
      return queued;
    }

    function applyPendingLineStates() {
      var drawer = getDrawer();
      if (!drawer) return;

      drawer.querySelectorAll('[data-cart-line-key]').forEach(function (item) {
        var action = pendingLineMutations.get(item.dataset.cartLineKey);
        if (action) {
          item.dataset.cartPendingAction = action;
          item.setAttribute('aria-busy', 'true');
        } else {
          item.removeAttribute('data-cart-pending-action');
          item.removeAttribute('aria-busy');
        }

        item.querySelectorAll('[data-cart-change]').forEach(function (control) {
          if (action) {
            if (!Object.prototype.hasOwnProperty.call(control.dataset, 'queueWasDisabled')) {
              control.dataset.queueWasDisabled = control.disabled ? 'true' : 'false';
            }
            control.disabled = true;
          } else if (Object.prototype.hasOwnProperty.call(control.dataset, 'queueWasDisabled')) {
            control.disabled = control.dataset.queueWasDisabled === 'true';
            delete control.dataset.queueWasDisabled;
          }
        });
      });
    }

    function replaceDrawer(sectionHtml, preserveOpen, focusState) {
      if (!sectionHtml) return;
      var currentDrawer = getDrawer();
      if (!currentDrawer) return;

      var body = currentDrawer.querySelector('.cart-drawer__body');
      var scrollTop = body ? body.scrollTop : 0;
      var noteDetails = currentDrawer.querySelector('[data-cart-note-details]');
      var expandedMethod = currentDrawer.querySelector('[data-cart-method][aria-expanded="true"]');
      var preservedFields = {};
      currentDrawer.querySelectorAll('[data-cart-note], [data-cart-quote-form] input:not([type="hidden"]), [data-cart-quote-form] select, [data-cart-quote-form] textarea:not([hidden])').forEach(function (field) {
        var key = field.name || field.id;
        if (key) preservedFields[key] = field.value;
      });

      var parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
      var nextDrawer = parsed.getElementById('CartDrawer');
      if (!nextDrawer) {
        var wrapper = document.createElement('div');
        wrapper.innerHTML = sectionHtml;
        nextDrawer = wrapper.querySelector('#CartDrawer');
      }
      if (!nextDrawer) return;

      currentDrawer.innerHTML = nextDrawer.innerHTML;
      currentDrawer.dataset.cartItemCount = nextDrawer.dataset.cartItemCount;
      currentDrawer.dataset.addedText = nextDrawer.dataset.addedText;
      currentDrawer.dataset.errorText = nextDrawer.dataset.errorText;
      currentDrawer.dataset.noteSavedText = nextDrawer.dataset.noteSavedText;
      currentDrawer.removeAttribute('aria-busy');

      var nextBody = currentDrawer.querySelector('.cart-drawer__body');
      if (nextBody) nextBody.scrollTop = scrollTop;

      var nextNoteDetails = currentDrawer.querySelector('[data-cart-note-details]');
      if (nextNoteDetails && noteDetails) nextNoteDetails.open = noteDetails.open;

      Object.keys(preservedFields).forEach(function (key) {
        currentDrawer.querySelectorAll('input, select, textarea').forEach(function (field) {
          if ((field.name || field.id) === key) field.value = preservedFields[key];
        });
      });

      if (expandedMethod) {
        var method = currentDrawer.querySelector('[data-cart-method="' + expandedMethod.dataset.cartMethod + '"]');
        if (method) selectMethod(method);
      }

      applyPendingLineStates();
      updateCartCount(Number(currentDrawer.dataset.cartItemCount || 0));
      if (preserveOpen && !currentDrawer.open) openDrawer(lastTrigger);

      if (focusState) {
        var focusTarget = Array.prototype.find.call(currentDrawer.querySelectorAll('[data-cart-change]'), function (control) {
          return control.dataset.lineKey === focusState.lineKey && control.dataset.cartAction === focusState.action;
        });
        if (focusTarget && focusTarget.disabled) {
          focusTarget = Array.prototype.find.call(currentDrawer.querySelectorAll('[data-cart-change]'), function (control) {
            return control.dataset.lineKey === focusState.lineKey && !control.disabled;
          });
        }
        if (!focusTarget) focusTarget = currentDrawer.querySelector('[data-cart-drawer-close]');
        if (focusTarget) focusTarget.focus({ preventScroll: true });
      }
    }

    async function refreshDrawer(preserveOpen, focusState) {
      var response = await fetch(getRoot() + '?section_id=cart-drawer', {
        headers: { Accept: 'text/html' },
        credentials: 'same-origin'
      });
      if (!response.ok) throw new Error('Cart section request failed');
      replaceDrawer(await response.text(), preserveOpen, focusState);
    }

    function addToCart(event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      var action = new URL(form.action, window.location.origin);
      if (!/\/cart\/add(?:\.js)?$/.test(action.pathname)) return;

      event.preventDefault();
      var submitter = event.submitter || form.querySelector('[type="submit"]');
      if (submitter && submitter.disabled) return;

      var label = submitter ? submitter.querySelector('[data-cart-button-text]') : null;
      var originalText = label ? label.textContent : '';
      var originalAriaLabel = submitter ? submitter.getAttribute('aria-label') : null;
      var formData = new FormData(form);
      formData.set('sections', getSectionsToRender().join(','));
      formData.set('sections_url', window.location.pathname);
      if (submitter) {
        submitter.disabled = true;
        submitter.setAttribute('aria-busy', 'true');
        submitter.setAttribute('aria-label', submitter.dataset.cartLoadingText || 'Adding to cart');
      }

      enqueueCartMutation(async function () {
        try {
          var response = await fetch(getRoot() + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: formData,
            credentials: 'same-origin'
          });
          var result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message);

          if (result.sections && result.sections['cart-drawer']) {
            replaceDrawer(result.sections['cart-drawer'], false);
          } else {
            await refreshDrawer(false);
          }

          var drawer = getDrawer();
          var addedText = drawer ? drawer.dataset.addedText : 'Added';
          dispatchCartSections(result.sections, 'cart-drawer');
          if (label) label.textContent = addedText;
          announce(addedText);
          window.setTimeout(function () {
            if (label && document.contains(label)) label.textContent = originalText;
          }, 800);
        } catch (error) {
          var drawer = getDrawer();
          announce(error.message || (drawer ? drawer.dataset.errorText : 'Unable to update the cart.'));
        } finally {
          if (submitter && document.contains(submitter)) {
            submitter.disabled = false;
            submitter.removeAttribute('aria-busy');
            if (originalAriaLabel === null) {
              submitter.removeAttribute('aria-label');
            } else {
              submitter.setAttribute('aria-label', originalAriaLabel);
            }
          }
        }
      });
    }

    function changeLine(button) {
      var drawer = getDrawer();
      if (!drawer || button.disabled) return;
      var errorElement = drawer.querySelector('[data-cart-error]');
      if (errorElement) errorElement.hidden = true;
      var lineKey = button.dataset.lineKey;
      var quantity = Number(button.dataset.quantity);
      var action = button.dataset.cartAction;
      var removeIndex = Array.prototype.indexOf.call(drawer.querySelectorAll('[data-cart-action="remove"]'), button);
      var focusState = {
        lineKey: lineKey,
        action: action
      };
      pendingLineMutations.set(lineKey, action);
      applyPendingLineStates();

      enqueueCartMutation(async function () {
        try {
          var response = await fetch(getRoot() + 'cart/change.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: lineKey,
              quantity: quantity,
              sections: getSectionsToRender().join(','),
              sections_url: window.location.pathname
            }),
            credentials: 'same-origin'
          });
          var result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message);

          var currentDrawer = getDrawer();
          var preserveOpen = Boolean(currentDrawer && currentDrawer.open);
          var restoreFocus = pendingLineMutations.size === 1 && action !== 'remove' ? focusState : null;
          if (result.sections && result.sections['cart-drawer']) {
            replaceDrawer(result.sections['cart-drawer'], preserveOpen, restoreFocus);
          } else {
            await refreshDrawer(preserveOpen, restoreFocus);
          }
          dispatchCartSections(result.sections, 'cart-drawer');
        } catch (error) {
          var currentDrawer = getDrawer();
          if (currentDrawer) {
            var message = error.message || currentDrawer.dataset.errorText;
            showCartError(message);
            announce(message);
          }
        } finally {
          pendingLineMutations.delete(lineKey);
          applyPendingLineStates();

          var currentDrawer = getDrawer();
          if (currentDrawer && currentDrawer.open && action === 'remove' && pendingLineMutations.size === 0) {
            var removeButtons = currentDrawer.querySelectorAll('[data-cart-action="remove"]');
            var focusTarget = removeButtons[Math.min(removeIndex, removeButtons.length - 1)] || currentDrawer.querySelector('[data-cart-drawer-close]');
            if (focusTarget) focusTarget.focus({ preventScroll: true });
          }
        }
      });
    }

    async function updateCartDetails(payload) {
      var response = await fetch(getRoot() + 'cart/update.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload),
        credentials: 'same-origin'
      });
      var result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message);
      return result;
    }

    function selectMethod(button) {
      var drawer = getDrawer();
      if (!drawer) return;
      var method = button.dataset.cartMethod;
      drawer.querySelectorAll('[data-cart-method]').forEach(function (methodButton) {
        methodButton.setAttribute('aria-expanded', methodButton === button ? 'true' : 'false');
      });
      drawer.querySelectorAll('[data-cart-method-panel]').forEach(function (panel) {
        panel.hidden = panel.dataset.cartMethodPanel !== method;
      });
    }

    async function pickupCheckout(button) {
      button.disabled = true;
      try {
        await updateCartDetails({ attributes: { 'Fulfillment method': 'Click & Collect' } });
        window.location.assign(getRoot() + 'checkout');
      } catch (error) {
        button.disabled = false;
        announce(error.message || getDrawer().dataset.errorText);
      }
    }

    function buildQuoteBody(form) {
      var drawer = getDrawer();
      var name = form.elements['contact[name]'].value.trim();
      var email = form.elements['contact[email]'].value.trim();
      var phone = form.elements['contact[phone]'].value.trim();
      var street = form.querySelector('[data-quote-street]').value.trim();
      var city = form.querySelector('[data-quote-city]').value.trim();
      var state = form.querySelector('[data-quote-state]').value;
      var postcode = form.querySelector('[data-quote-postcode]').value.trim();
      var message = form.querySelector('[data-quote-message]').value.trim();
      var lines = [
        'DELIVERY QUOTE REQUEST',
        '',
        'Customer: ' + name,
        'Email: ' + email,
        'Phone: ' + phone,
        '',
        'Delivery address:',
        street,
        city + ', ' + state + ' ' + postcode
      ];

      if (message) lines.push('', 'CUSTOMER MESSAGE', message);
      lines.push('', 'CART ITEMS');

      drawer.querySelectorAll('.cart-drawer__item').forEach(function (item, index) {
        var title = item.querySelector('.cart-drawer__item-title').textContent.trim();
        var variant = item.querySelector('.cart-drawer__variant');
        var quantity = item.querySelector('[data-cart-quantity]').textContent.trim();
        var price = item.querySelector('.cart-drawer__line-price').textContent.trim();
        lines.push((index + 1) + '. ' + title + (variant ? ' - ' + variant.textContent.trim() : ''));
        lines.push('   Qty: ' + quantity + ' | Line total: ' + price);
      });

      var subtotal = drawer.querySelector('.cart-drawer__subtotal strong');
      lines.push('', 'SUBTOTAL: ' + (subtotal ? subtotal.textContent.trim() : ''));
      var note = drawer.querySelector('[data-cart-note]');
      if (note && note.value.trim()) lines.push('', 'ORDER NOTE', note.value.trim());
      return lines.join('\n');
    }

    function prepareQuoteSubmission(event) {
      var form = event.target;
      if (form.dataset.submitting === 'true') {
        event.preventDefault();
        return;
      }

      var submitter = event.submitter || form.querySelector('[type="submit"]');
      var errorElement = form.querySelector('[data-cart-quote-error]');
      if (errorElement) errorElement.hidden = true;
      form.querySelector('[data-cart-quote-body]').value = buildQuoteBody(form);
      form.dataset.submitting = 'true';
      if (submitter) {
        submitter.disabled = true;
        submitter.setAttribute('aria-busy', 'true');
      }
    }

    var noteSaveTimer;
    function scheduleNoteSave(textarea) {
      window.clearTimeout(noteSaveTimer);
      noteSaveTimer = window.setTimeout(async function () {
        try {
          await updateCartDetails({ note: textarea.value });
          var drawer = getDrawer();
          announce(drawer ? drawer.dataset.noteSavedText : 'Order note saved.');
        } catch (error) {
          announce(error.message || getDrawer().dataset.errorText);
        }
      }, 500);
    }

    window.addEventListener('submit', function (event) {
      if (!event.target.matches('[data-cart-quote-form]')) return;
      prepareQuoteSubmission(event);
    }, true);

    document.addEventListener('submit', function (event) {
      if (event.defaultPrevented) return;
      addToCart(event);
    });

    document.addEventListener('input', function (event) {
      if (event.target.matches('[data-cart-note]')) scheduleNoteSave(event.target);
    });

    document.addEventListener('ibpals:cart-sections', function (event) {
      var detail = event.detail || {};
      if (detail.source === 'cart-drawer') return;
      var sectionHtml = detail.sections && detail.sections['cart-drawer'];
      if (!sectionHtml) return;
      var drawer = getDrawer();
      replaceDrawer(sectionHtml, Boolean(drawer && drawer.open));
      updateCartCount(Number(detail.itemCount || 0));
    });

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-cart-drawer-trigger]');
      if (trigger) {
        event.preventDefault();
        openDrawer(trigger);
        return;
      }

      if (event.target.closest('[data-cart-drawer-close]')) {
        closeDrawer();
        return;
      }

      var changeButton = event.target.closest('[data-cart-change]');
      if (changeButton) {
        event.preventDefault();
        changeLine(changeButton);
        return;
      }

      var methodButton = event.target.closest('[data-cart-method]');
      if (methodButton) {
        event.preventDefault();
        selectMethod(methodButton);
        return;
      }

      var pickupButton = event.target.closest('[data-pickup-checkout]');
      if (pickupButton) {
        event.preventDefault();
        pickupCheckout(pickupButton);
        return;
      }

      var drawer = getDrawer();
      if (drawer && event.target === drawer) closeDrawer();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
